import styled, { css } from 'styled-components';
import MaskedInput from 'react-text-mask';
import InputMask from 'react-input-mask';

import CheckMark from '../icons/CheckMark';
import ErrorSvg from '../icons/ErrorIcon';

const labelOffSetWhenFocusedAndPopulated = '-20px';
const textareaLabelOffSetWhenFocusedAndPopulated = '9px';
const iconOffSet = '5px';

export const CheckmarkIcon = styled(CheckMark)`
  color: ${props => props.theme.carvana.green.primary};
  position: absolute;
  top: ${iconOffSet};
  right: ${iconOffSet};
  width: 20px;
  height: 20px;
`;

export const ErrorIcon = styled(ErrorSvg)`
  color: ${props => props.theme.carvana.red.primary};
  width: 20px;
  height: 20px;
  position: absolute;
  top: ${iconOffSet};
  right: ${iconOffSet};
`;

export const PasswordToggler = styled.div`
  display: none;
  cursor: pointer;
  position: absolute;
  color: ${props => props.theme.carvana.blue.primary};
  font-size: 14px;
  right: 9px;
  bottom: 5px;

  &:hover {
    display: block;
  }
`;

const hideValdiationIconsWhenFocused = css`
  &:focus ~ ${CheckmarkIcon} {
    display: none;
  }
`;

const showPasswordToggleWhenFocused = css`
  &:focus ~ ${PasswordToggler}, &:hover ~ ${PasswordToggler} {
    display: block;
  }
`;

export const InputWrapper = styled.div`
  font-family: ${props => props.theme.typography.fontFamily};
  width: 300px;
`;

export const InputContainer = styled.div`
  display: flex;
  position: relative;
  background-color: ${props => props.theme.carvana.white.primary};
  border-radius: 3px;
  &.is-disabled {
    cursor: not-allowed;
    background-color: ${props => props.theme.carvana.gray.background};
  }
`;

const inputCss = css`
  box-sizing: border-box;
  height: 56px;
  width: 100%;
  background: ${props => props.theme.carvana.white.primary};
  border: 1px solid ${props => props.theme.carvana.gray.light};
  padding: 0 19px;
  flex: 1;
  border-radius: 3px;
  outline: none;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: ${props => props.theme.carvana.blue.dark};

  &.light {
    background: ${props => props.theme.carvana.gray.background};
  }

  &.dark {
    background: ${props => props.theme.carvana.white.primary};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${props => props.theme.carvana.gray.background};
  }

  &:focus {
    border: 1px solid ${props => props.theme.carvana.blue.primary};
  }

  &:focus ~ label {
    top: ${labelOffSetWhenFocusedAndPopulated};
    color: ${props => props.theme.carvana.blue.primary};
    font-size: 12px;
  }

  &:focus ~ label.textarea {
    top: ${textareaLabelOffSetWhenFocusedAndPopulated};
  }

  ${hideValdiationIconsWhenFocused}
  ${showPasswordToggleWhenFocused}


  &.has-label {
    padding: 14px 19px 0 19px;
  }

  &.has-label.textarea {
    padding: 30px 19px 0 19px;
  }

  &.has-password {
    padding-right: 49px;
  }

  &.show-error-icon {
    border-color: ${props => props.theme.carvana.red.primary};

    ~ label {
      color: ${props => props.theme.carvana.red.primary};
    }
  }

  &.is-populated {
    & ~ label {
      font-size: 12px;
      top: ${labelOffSetWhenFocusedAndPopulated};
    }
    & ~ label.textarea {
      top: ${textareaLabelOffSetWhenFocusedAndPopulated};
    }
  }

  @keyframes onAutoFillStart {
  }
  @keyframes onAutoFillCancel {
  }

  &:-webkit-autofill {
    animation-name: onAutoFillStart;
    transition: background-color 50000s ease-in-out 0s;
  }

  &:not(:-webkit-autofill) {
    animation-name: onAutoFillCancel;
  }
`;

export const TextAreaInput = styled.textarea`
  ${inputCss}
  height: 154px;
  padding-top: 30px;
`;

export const FormInput = styled.input`
  ${inputCss}
`;

export const TextMaskedInput = styled(InputMask)`
  ${inputCss}
`;

export const IncomeMaskedInput = styled(MaskedInput)`
  ${inputCss}
`;

export const SsnMaskedInput = styled(MaskedInput)`
  ${inputCss}
`;

export const Label = styled.label`
  display: flex;
  font-size: 16px;
  line-height: 20px;
  position: absolute;
  pointer-events: none;
  user-select: none;
  align-items: center;
  top: 0;
  bottom: 0;
  left: 19px;
  cursor: text;
  margin: 0px auto;
  color: ${props => props.theme.carvana.gray.dark};
  transition: all 150ms ease-in-out;

  &.is-disabled {
    cursor: not-allowed;
    color: ${props => props.theme.carvana.gray.light};
  }

  &.textarea {
    top: 11px;
    bottom: auto;
  }
`;

export const DescriptionContainer = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 12px;
  line-height: 16px;
  margin: 6px 0;
`;

export const ErrorMessageContainer = styled.div`
  color: ${props => props.theme.carvana.red.primary};
  font-weight: 400;
  font-size: 12px;
  text-align: left;
`;
